import {breakpoints} from '../../../variables/variables.js';

const swiperMixin = {
  computed: {
    isSimulateTouch() {
      return window.innerWidth < breakpoints.laptop;
    },
  },
};

export default swiperMixin;
